<template>
    <span>
        <v-list-tile @click="mostrarCaixaDialogo">
            <v-list-tile-title>
                Solicitar Negociação
            </v-list-tile-title>
        </v-list-tile>
        <v-dialog :max-width="Modal.Confirmacao.larguraMaxima" persistent v-model="visibilidadeDialogo">
            <v-card :max-width="Modal.Confirmacao.larguraMaxima" :min-width="Modal.Confirmacao.larguraMinima">
                <v-card-title class="primary modal-title" primary-title>
                    <span><strong>{{itemOuLoteDescricao}}</strong> | Solicitar Negociação</span>
                    <v-btn flat depressed @click="fecharCaixaDialogo">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-card-text class="pb-0 az-form-content">
                    <v-flex d-flex>
                          <v-flex d-flex xs12 sm7>
                                <div class="az-text">
                                    <label>Fornecedor</label>
                                    <p>{{razaoSocial}}</p>
                                </div>
                          </v-flex>
                          <v-flex d-flex xs12 sm5>
                                <div class="az-text">
                                    <label>Lance Vencedor</label>
                                    <p>{{ lanceVencedor | cdCurrency(prefix, casasDecimais)}}{{suffix}}</p>
                                </div>
                          </v-flex>
                    </v-flex>

                    <v-textarea v-model="mensagem"
                                :error-messages="errors.collect('Mensagem ' + itemOuLoteDescricao)"
                                v-validate="'required'"
                                :name="'Mensagem ' + itemOuLoteDescricao"
                                label="Mensagem"
                                placeholder="Digite aqui sua mensagem"
                                rows="3"
                                maxlength="1000"
                                :counter="1000"/>
                </v-card-text>

                <v-card-actions class="px-3 py-2">
                    <v-btn color="botao-cancelar-color" outline flat @click="fecharCaixaDialogo">
                        Cancelar
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn id="botaoNegociar" color="primary" depressed @click="negociar">
                        Negociar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </span>
</template>

<script>

import {Modal} from '@/core/constants'

export default {
    name: 'AcoesNegociar',
    $_veeValidate: {
        validator: 'new'
    },
    props: ['itemOuLoteDescricao', 'razaoSocial', 'lanceVencedor', 'casasDecimais', 'prefix', 'suffix'],
    data() {
        return {
            visibilidadeDialogo: false,
            mensagem: null,
            campoNaoPreenchido: true,
            Modal
        }
    },
    methods: {
        async negociar() {
            await this.validarPreenchimento()
            this.$emit('negociar', {mensagem: this.mensagem})
            this.fecharCaixaDialogo()
        },
        async validarPreenchimento() {
            const campoValido = await this.$validator.validate('Mensagem ' + this.itemOuLoteDescricao)
            if (!campoValido) {
                this.campoNaoPreenchido = false
                throw new Error('Preencha todos os campos obrigatórios.')
            }
        },
        mostrarCaixaDialogo() {
            setTimeout(() => {
                this.limparCamposNegociacao()
                this.visibilidadeDialogo = true
            }, 500)
        },
        fecharCaixaDialogo() {
            this.limparCamposNegociacao()
            this.visibilidadeDialogo = false
        },
        limparCamposNegociacao() {
            this.valor = null
            this.mensagem = null
            this.campoNaoPreenchido = true
            this.$validator.reset()
        }
    },
    destroyed() {
        this.fecharCaixaDialogo()
    }
}
</script>

<style scoped lang="stylus">
    .modal-title
        justify-content space-between

        .v-btn
            padding 0
            margin 0
            color #fff
            box-sizing border-box
            min-width 25px

    .botao-primario
        padding 0 25px
        border 1px solid var(--v-primary-base) !important
        background-color var(--v-primary-base) !important
        color #fff !important
        box-sizing border-box
        margin-left 15px !important
</style>